import SearchResultSummary from './SearchResultSummary';

export default SearchResultSummary;
